<template>
    <div class="mt-2 flex flex-column gap-5 align-items-start" style="color: var(--theme-font-color);">

        <!-- PROFILE SETTINGS -->
        <div class="flex flex-column align-items-start px-3 py-3" style="width: 100%; background-color: var(--profile-block-background-color); border-radius: var(--my-border-radius);">

            <!-- First Name block -->
            <div class="w-full flex flex-column px-4 py-3" :class="{'selected-block': selectedBlock === 'firstName'}">
                <div class="w-full flex flex-row align-items-start" :class="{ 'mb-5': errorFirstNameMessage}">
                    <div class="flex flex-row align-items-start mr-4 gap-2" style="width: 82%;">
                        <span class="section-title mt-1" style="width: 28%;">First Name</span>
                        <div v-if="selectedBlock !== 'firstName'" class="relative" style="width: 72%;">
                            <div class="section-value flex" style="max-width: 100%;">
                                <span class="potentially-long-label" style="font-size: var(--inputcomponent-big-font-size); font-weight: var(--inputcomponent-font-weight);">{{ user.first_name }}</span>
                            </div>
                        </div>
                        <div v-else class="relative" style="width: 72%;">
                            <InputText ref="refInputTextFirstName" @vue:mounted="refInputTextFirstName.$el.focus()" class="inputtext-big section-inputtext w-full" v-model="newFirstName" aria-describedby="admin-help" :class="{'p-invalid': errorFirstNameMessage && isValidFirstName(newFirstName)!=='success'}"/>
                            <span v-if="errorFirstNameMessage" class="error-message absolute mb-2" style="top: 2.9rem; left: 0; color: var(--inputcomponent-invalid-color);">{{ errorFirstNameMessage }}</span>
                        </div>
                    </div>
                    <div class="buttons-change-cancel mt-1 flex flex-row align-items-center justify-content-end" style="width: 18%">
                        <Button v-if="selectedBlock!=='firstName'" text label="Change" style="flex: end;" @click="clickedButtonFirstName"/>
                        <Button v-else text label="Cancel" style="flex: end;" @click="clickedButtonFirstName"/>
                    </div>
                </div>

                <!-- Showing when editing FIRSTNAME -->
                <div v-if="selectedBlock === 'firstName'" class="flex flex-column mt-4">
                    <!-- Save button -->
                    <div class="w-full flex flex-row align-items-center" >
                        <div class="flex flex-row align-items-center mr-4 gap-2" style="width: 82%;">
                            <div style="width: 28%;"/>
                            <div style="width: 72%;" class="flex justify-content-end">
                                <ButtonModule type="primary" severity="normal" label="Save Changes" @click="clickedSubmitFirstNameChange(newFirstName)" :disabled="!enableChangeFirstNameSubmit"/>
                            </div>
                        </div>
                        <div style="width: 18%;"/>
                    </div>
                </div>
            </div>

            <!-- Last Name block -->
            <div class="w-full flex flex-column px-4 py-3" :class="{'selected-block': selectedBlock === 'lastName'}">
                <div class="w-full flex flex-row align-items-start" :class="{ 'mb-5': errorLastNameMessage}">
                    <div class="flex flex-row align-items-start mr-4 gap-2" style="width: 82%;">
                        <span class="section-title mt-1" style="width: 28%;">Last Name</span>
                        <div v-if="selectedBlock !== 'lastName'" class="relative" style="width: 72%;">
                            <div class="section-value flex" style="max-width: 100%; padding: 0.27rem 0.7rem;">
                                <span class="potentially-long-label" style="font-size: var(--inputcomponent-big-font-size); font-weight: var(--inputcomponent-font-weight);">{{ user.last_name }}</span>
                            </div>
                        </div>
                        <div v-else class="relative" style="width: 72%;">
                            <InputText ref="refInputTextLastName" @vue:mounted="refInputTextLastName.$el.focus()" class="inputtext-big section-inputtext w-full" v-model="newLastName" aria-describedby="admin-help" :class="{'p-invalid': errorLastNameMessage && isValidLastName(newLastName)!=='success'}"/>
                            <span v-if="errorLastNameMessage" class="error-message absolute mb-2" style="top: 2.9rem; left: 0; color: var(--inputcomponent-invalid-color);">{{ errorLastNameMessage }}</span>
                        </div>
                    </div>
                    <div class="buttons-change-cancel mt-1 flex flex-row align-items-center justify-content-end" style="width: 18%">
                        <Button v-if="selectedBlock!=='lastName'" text label="Change" style="flex: end;" @click="clickedButtonLastName"/>
                        <Button v-else text label="Cancel" style="flex: end;" @click="clickedButtonLastName"/>
                    </div>
                </div>

                <!-- Showing when editing LASTNAME -->
                <div v-if="selectedBlock === 'lastName'" class="flex flex-column mt-4">
                    <!-- Save button -->
                    <div class="w-full flex flex-row align-items-center" >
                        <div class="flex flex-row align-items-center mr-4 gap-2" style="width: 82%;">
                            <div style="width: 28%;"/>
                            <div style="width: 72%;" class="flex justify-content-end">
                                <ButtonModule type="primary" severity="normal" label="Save Changes" @click="clickedSubmitLastNameChange(newLastName)" :disabled="!enableChangeLastNameSubmit"/>
                            </div>
                        </div>
                        <div style="width: 18%;"/>
                    </div>
                </div>
            </div>

            <!-- Company block -->
            <div class="w-full flex flex-column px-4 py-3" :class="{'selected-block': selectedBlock === 'company'}">
                <div class="w-full flex flex-row align-items-start" :class="{ 'mb-5': errorCompanyMessage}">
                    <div class="flex flex-row align-items-start mr-4 gap-2" style="width: 82%;">
                        <span class="section-title mt-1" style="width: 28%;">Company</span>
                        <div v-if="selectedBlock !== 'company'" class="relative" style="width: 72%;">
                            <div class="section-value flex" style="max-width: 100%; padding: 0.27rem 0.7rem;">
                                <span class="potentially-long-label" style="font-size: var(--inputcomponent-big-font-size); font-weight: var(--inputcomponent-font-weight);">{{ user.company ? user.company : '/' }}</span>
                            </div>
                        </div>
                        <div v-else class="relative" style="width: 72%;">
                            <InputText ref="refInputTextCompany" @vue:mounted="refInputTextCompany.$el.focus()" class="inputtext-big section-inputtext w-full" v-model="newCompany" aria-describedby="admin-help" :class="{'p-invalid': errorCompanyMessage && isValidCompany(newCompany)!=='success'}"/>
                            <span v-if="errorCompanyMessage" class="error-message absolute mb-2" style="top: 2.9rem; left: 0; color: var(--inputcomponent-invalid-color);">{{ errorCompanyMessage }}</span>
                        </div>
                    </div>
                    <div class="buttons-change-cancel mt-1 flex flex-row align-items-center justify-content-end" style="width: 18%">
                        <Button v-if="selectedBlock!=='company'" text label="Change" style="flex: end;" @click="clickedButtonCompany"/>
                        <Button v-else text label="Cancel" style="flex: end;" @click="clickedButtonCompany"/>
                    </div>
                </div>

                <!-- Showing when editing COMPANY -->
                <div v-if="selectedBlock === 'company'" class="flex flex-column mt-4">
                    <!-- Save button -->
                    <div class="w-full flex flex-row align-items-center" >
                        <div class="flex flex-row align-items-center mr-4 gap-2" style="width: 82%;">
                            <div style="width: 28%;"/>
                            <div style="width: 72%;" class="flex justify-content-end">
                                <ButtonModule type="primary" severity="normal" label="Save Changes" @click="clickedSubmitCompanyChange(newCompany)" :disabled="!enableChangeCompanySubmit"/>
                            </div>
                        </div>
                        <div style="width: 18%;"/>
                    </div>
                </div>
            </div>

            <!-- Country block -->
            <div class="w-full flex flex-column px-4 py-3" :class="{'selected-block': selectedBlock === 'country'}">
                <div class="w-full flex flex-row align-items-start">
                    <div class="flex flex-row align-items-start mr-4 gap-2" style="width: 82%;">
                        <span class="section-title mt-1" style="width: 28%;">Country</span>
                        <div v-if="selectedBlock !== 'country'" class="relative" style="width: 72%;">
                            <div class="section-value" style="padding: 0.33rem 0.7rem;">
                                <div v-if="user.country.length>0" class="flex flex-row align-items-center gap-3">
                                    <FlagIcon v-if="countries.filter((country) => country.code === user.country).length>0 && user.country.length>0" :countryCode="user.country.toLowerCase()" size="big"/>
                                    <span style="font-size: var(--inputcomponent-big-font-size); font-weight: var(--inputcomponent-font-weight);">{{ countries.filter((country) => country.code === user.country).length>0 ? countries.filter((country) => country.code === user.country)[0].countryName : user.country }}</span>
                                </div>
                                <span v-else style="font-size: var(--inputcomponent-big-font-size); font-weight: var(--inputcomponent-font-weight);">/</span>
                            </div>
                        </div>
                        <div v-else class="relative" style="width: 72%;">
                            <CountryDropdown class="dropdown-big" dropdownSize="big" :initialSelectedCountryCode="user.country" @selectCountry="(val) => newCountry = val" :selectedCountryCode="newCountry"/>
                        </div>
                    </div>
                    <div class="buttons-change-cancel mt-1 flex flex-row align-items-center justify-content-end" style="width: 18%">
                        <Button v-if="selectedBlock!=='country'" text label="Change" style="flex: end;" @click="clickedButtonCountry"/>
                        <Button v-else text label="Cancel" style="flex: end;" @click="clickedButtonCountry"/>
                    </div>
                </div>

                <!-- Showing when editing COUNTRY -->
                <div v-if="selectedBlock === 'country'" class="flex flex-column mt-4">
                    <!-- Save button -->
                    <div class="w-full flex flex-row align-items-center" >
                        <div class="flex flex-row align-items-center mr-4 gap-2" style="width: 82%;">
                            <div style="width: 28%;"/>
                            <div style="width: 72%;" class="flex justify-content-end">
                                <ButtonModule type="primary" severity="normal" label="Save Changes" @click="clickedSubmitCountryChange(newCountry)" :disabled="!enableChangeCountrySubmit"/>
                            </div>
                        </div>
                        <div style="width: 18%;"/>
                    </div>
                </div>
            </div>

            <!-- Email block -->
            <div class="w-full flex flex-column gap-3 px-4 py-3" :class="{'selected-block': selectedBlock === 'email'}">
                <div class="w-full flex flex-row align-items-start" :class="{ 'mb-4': errorEmailMessage || emailNotFree}">
                    <div class="flex flex-row align-items-start mr-4 gap-2" style="width: 82%;">
                        <span class="section-title mt-1" style="width: 28%;">Email</span>
                        <div v-if="selectedBlock !== 'email'" class="relative" style="width: 72%;">
                            <div class="section-value flex" style="">
                                <span class="potentially-long-label" style="font-size: var(--inputcomponent-big-font-size); font-weight: var(--inputcomponent-font-weight);">{{ user.email }}</span>
                            </div>
                        </div>
                        <div v-else class="relative" style="width: 72%;">
                            <InputText ref="refInputTextEmail1" @vue:mounted="refInputTextEmail1.$el.focus()" class="inputtext-big section-inputtext w-full" v-model="newEmail1" aria-describedby="admin-help" :class="{'p-invalid': errorEmailMessage && isValidEmail(newEmail1)!=='success'}"/>
                            <span v-if="errorEmailMessage" class="error-message absolute mb-2" style="top: 2.9rem; left: 0; color: var(--inputcomponent-invalid-color);">{{ errorEmailMessage }}</span>
                            <span v-else-if="emailNotFree" class="subtext absolute mb-2" style="left: 0; top: 2.9rem; color: var(--inputcomponent-invalid-color);">The email is already assigned to another user.</span>
                        </div>
                    </div>
                    <div class="buttons-change-cancel mt-1 flex flex-row align-items-center justify-content-end" style="width: 18%;">
                        <Button v-if="selectedBlock!=='email'" text label="Change" style="flex: end;" @click="clickedButtonEmail"/>
                        <Button v-else text label="Cancel" style="flex: end;" @click="clickedButtonEmail"/>
                    </div>
                </div>

                <!-- Showing when editing EMAIL -->
                <div v-if="selectedBlock === 'email'" class="flex flex-column gap-4">
                    <!-- New Email confirmation -->
                    <div class="w-full flex flex-row align-items-center">
                        <div class="flex flex-row align-items-center mr-4 gap-2" style="width: 82%;">
                            <div style="width: 28%;"/>
                            <div style="width: 72%;">
                                <InputText class="inputtext-big section-inputtext w-full" v-model="newEmail2" aria-describedby="admin-help" placeholder="Email Confirmation" :class="{'p-disabled': selectedBlock !== 'email', 'p-invalid': (newEmail1 !== newEmail2) && newEmail2}"/>
                            </div>
                        </div>
                        <div style="width: 18%;"/>
                    </div>
                    <!-- Save button -->
                    <div class="w-full flex flex-row align-items-center" >
                        <div class="flex flex-row align-items-center mr-4 gap-2" style="width: 82%;">
                            <div style="width: 28%;"/>
                            <div style="width: 72%;" class="flex justify-content-end">
                                <ButtonModule type="primary" severity="normal" label="Save Changes" @click="clickedSubmitEmailChange(newEmail1)" :disabled="!enableChangeEmailSubmit"/>
                            </div>
                        </div>
                        <div style="width: 18%;"/>
                    </div>
                </div>
            </div>

            <!-- Password block -->
            <div class="w-full flex flex-column gap-3 px-4 py-3" :class="{'selected-block': selectedBlock === 'password'}">
                <div class="w-full flex flex-row align-items-start" style="min-height: 3rem;">
                    <div class="flex flex-row align-items-start mr-4 gap-2" style="width: 82%;">
                        <span class="section-title mt-1" style="width: 28%;">Password</span>
                        <div style="width: 72%;">
                            <div v-if="selectedBlock === 'password'">
                                <PasswordInputText :focusWhenMounted="true" v-model:val="newPassword1" class="inputtext-big section-password" uid="passwordChange1" :isInvalid="errorPasswordMessage && isValidPasswordRegister(newPassword1)!=='success'" style="font-weight: 100;" @update-val="(val) => newPassword1=val"/>
                                <span v-if="errorPasswordMessage" class="error-message" style="top: 2.9rem; left: 0; color: var(--inputcomponent-invalid-color);">{{ errorPasswordMessage }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="buttons-change-cancel mt-1 flex flex-row align-items-center justify-content-end" style="width: 18%">
                        <Button v-if="selectedBlock!=='password'" text label="Change" style="flex: end;" @click="clickedButtonPassword"/>
                        <Button v-else text label="Cancel" style="flex: end;" @click="clickedButtonPassword"/>
                    </div>
                </div>

                <!-- Showing when editing PASSWORD -->
                <div v-if="selectedBlock === 'password'" class="flex flex-column gap-4">
                    <!-- New Password confirmation -->
                    <div class="w-full flex flex-row align-items-center" >
                        <div class="flex flex-row align-items-center mr-4 gap-2" style="width: 82%;">
                            <div style="width: 28%;"/>
                            <div style="width: 72%;">
                                <PasswordInputText v-model:val="newPassword2" class="inputtext-big section-password" uid="passwordChange1" placeholder="Password Confirmation" :isInvalid="newPassword1 !== newPassword2" style="font-weight: 100;" @update-val="(val) => newPassword2=val"/>
                                <span v-if="!errorPasswordMessage" class="error-message" style="top: 2.9rem; left: 0; color: var(--theme-font-color); opacity: 0.6;">{{ invalidPasswordMessage }}</span>
                            </div>
                        </div>
                        <div style="width: 18%;"/>
                    </div>
                    <!-- Save button -->
                    <div class="w-full flex flex-row align-items-center" >
                        <div class="flex flex-row align-items-center mr-4 gap-2" style="width: 82%;">
                            <div style="width: 28%;"/>
                            <div style="width: 72%;" class="flex justify-content-end">
                                <ButtonModule type="primary" severity="normal" label="Save Changes" @click="clickedSubmitPasswordChange" :disabled="!enableChangePasswordSubmit"/>
                            </div>
                        </div>
                        <div style="width: 18%;"/>
                    </div>
                </div>
            </div>
        </div>

        <!-- THEME SETTING -->
        <div class="flex flex-column gap-1 align-items-center px-3 py-3" style="width: 100%; background-color: var(--profile-block-background-color); border-radius: var(--my-border-radius);">
            <div class="w-full flex flex-row align-items-center px-4 py-2">
                <div class="flex flex-row align-items-center" style="flex: 1;">
                    <span class="section-title" style="width: 28%;">Theme</span>
                    <div style="width: 72%;">
                        <DarkLightToggle style="width: 9.5rem;"/>
                    </div>
                </div>
                <span style="flex: end; width: 25px;"/>
            </div>
        </div>

        <!-- Delete account block -->
        <ButtonModule class="align-self-end" type="secondary" severity="danger" label="Delete Account" @click="showConfirmationDeleteAccountDialog = true" style="margin-bottom: 3rem;"/>
    </div>


    <!-- DIALOGS -->

    <!-- Authentication using PASSWORD -->
    <VerificationAuthenticationDialog :showDialog="showPasswordVerificationDialog" :incorrectPassword="wrongPassword" @cancel="showPasswordVerificationDialog = false;" @ok="(val) => verificationAuthenticationDone(val)" :isLoading="httpEditProfileLoading"/>
        
    <!-- EmailUpdateDoneDialog window -->
    <EmailUpdateDoneDialog :showDialog="showEmailUpdateDoneDialog" :requestContent="emailRequestContent" @close="showEmailUpdateDoneDialog = false; $emit('refresh-profile-info');"/>

    <!-- Confirmation Delete Account window -->
    <ConfirmationDeleteAccountDialog :showDialog="showConfirmationDeleteAccountDialog" @close="showConfirmationDeleteAccountDialog = false"/>
</template>

<script setup>
// --- IMPORTS ---
import { ref, computed, watchEffect, onMounted, onBeforeUnmount } from 'vue';
// PrimeVue
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
// vue
import ButtonModule from '@/components/Modules/ButtonModule.vue';
import PasswordInputText from '@/components/Modules/PasswordInputText.vue'
import VerificationAuthenticationDialog from '@/components/Dialogs/OtherDialogs/VerificationAuthenticationDialog.vue'
import DarkLightToggle from '@/components/Modules/DarkLightToggle.vue';
import CountryDropdown from '@/components/Modules/CountryDropdown.vue';
import FlagIcon from "@/components/Modules/FlagIcon.vue";
import EmailUpdateDoneDialog from '@/components/Dialogs/OtherDialogs/EmailUpdateDoneDialog.vue'
import ConfirmationDeleteAccountDialog from '@/components/Dialogs/Actions/ConfirmationDeleteAccountDialog.vue';
// Others
import InputsUtils from '@/composables/InputsUtils'
import CountriesUtils from '@/composables/CountriesUtils'
import toastService from '@/composables/toastService';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import UserUtils from '@/composables/UserUtils';

const { isValidFirstName, isValidLastName, isValidCompany, isValidEmail, invalidPasswordMessage, isValidPasswordRegister } = InputsUtils()
const { countries } = CountriesUtils()
const store = useStore()
const router = useRouter()
const { logoutUser } = UserUtils(store, router)

// API
import useApiRequest from '@/composables/HTTPS/useApiRequest';
const { fetchEditProfile } = useApiRequest()
const httpEditProfileLoading = ref(false)
const httpEditProfileData = ref(null)

// --- EMITS ---
const emit = defineEmits(['refresh-profile-info'])

// --- User info ---
const user = computed(() => store.state.user.user)

// --- EDITING ---
const selectedBlock = ref(null)
// -- Variables --
// - FirstName
const newFirstName = ref(null)
const errorFirstNameMessage = ref(null)
const refInputTextFirstName = ref(null)
// - Last Name
const newLastName = ref(null)
const errorLastNameMessage = ref(null)
const refInputTextLastName = ref(null)
// - Company
const newCompany = ref(null)
const errorCompanyMessage = ref(null)
const refInputTextCompany = ref(null)
// - Country
const newCountry = ref(null)
const refInputTextCountry = ref(null)
// - Email
const newEmail1 = ref(null)
const errorEmailMessage = ref(null)
const emailNotFree = ref(false)
const refInputTextEmail1 = ref(null)
const newEmail2 = ref(null)
// - Password
const newPassword1 = ref(null)
const errorPasswordMessage = ref(null)
const newPassword2 = ref(null)
// -- Submit buttons enabled/disabled --
const enableChangeFirstNameSubmit = computed(() => newFirstName.value!==null && newFirstName.value.length>0 )
const enableChangeLastNameSubmit = computed(() => newLastName.value!==null && newLastName.value.length>0 )
const enableChangeCompanySubmit = computed(() => true )
const enableChangeCountrySubmit = computed(() => true )
const enableChangeEmailSubmit = computed(() => (newEmail1.value!==null && newEmail2.value!==null) && (newEmail1.value === newEmail2.value) && newEmail2.value.length>0 && newEmail2.value.length>0)
const enableChangePasswordSubmit = computed(() => (newPassword1.value!==null && newPassword2.value!==null) && (newPassword1.value === newPassword2.value) && newPassword1.value.length>0 && newPassword2.value.length>0)

// -- Watch change block --
watchEffect(() => {
    if (selectedBlock.value!=='firstName') { newFirstName.value = null; errorFirstNameMessage.value = null }
    if (selectedBlock.value!=='lastName') { newLastName.value = null; errorLastNameMessage.value = null }
    if (selectedBlock.value!=='company') { newCompany.value = null; errorCompanyMessage.value = null }
    if (selectedBlock.value!=='country') { newCountry.value = null; }
    if (selectedBlock.value!=='email') { newEmail1.value = null; newEmail2.value = null; errorEmailMessage.value = null; emailNotFree.value = false }
    if (selectedBlock.value!=='password') { newPassword1.value = null; newPassword2.value = null; errorPasswordMessage.value = null }

    if (selectedBlock.value==='firstName') { newFirstName.value = user.value.first_name }
    if (selectedBlock.value==='lastName') { newLastName.value = user.value.last_name }
    if (selectedBlock.value==='company') { newCompany.value = user.value.company ? user.value.company : '' }
    if (selectedBlock.value==='country') { newCountry.value = user.value.country ? user.value.country : '' }
    if (selectedBlock.value==='email') { newEmail1.value = user.value.email }
})

// --- OPENING SECTIONS ---
const clickedButtonFirstName = () => {
    if (selectedBlock.value === 'firstName') { selectedBlock.value = null }
    else {
        selectedBlock.value = 'firstName'
    }
}
const clickedButtonLastName = () => {
    if (selectedBlock.value === 'lastName') { selectedBlock.value = null }
    else {
        selectedBlock.value = 'lastName'
    }
}
const clickedButtonCompany = () => {
    if (selectedBlock.value === 'company') { selectedBlock.value = null }
    else {
        selectedBlock.value = 'company'
    }
}
const clickedButtonCountry = () => {
    if (selectedBlock.value === 'country') { selectedBlock.value = null }
    else {
        selectedBlock.value = 'country'
    }
}
const clickedButtonEmail = () => {
    if (selectedBlock.value === 'email') { selectedBlock.value = null }
    else {
        selectedBlock.value = 'email'
    }
}
const clickedButtonPassword = () => {
    if (selectedBlock.value === 'password') { selectedBlock.value = null }
    else {
        selectedBlock.value = 'password'
    }
}

// --- CHANGES ---
const changeRequest = ref(null)
// - SUBMIT BUTTONS -
const clickedSubmitFirstNameChange = ( myNewFirstName) => {
    const messageValidity = isValidFirstName(myNewFirstName)
    // The new first name must be different than the current one ...
    if (myNewFirstName === user.value.first_name) { 
        // Equivalent to quit the block because there is no change ...
        selectedBlock.value = null
    }
    // Check if first name valid
    else if (messageValidity !== 'success') {
        errorFirstNameMessage.value = messageValidity
    }
    else {
        // HERE WE HAVE THE HTTP REQUEST OBJECT
        changeRequest.value = {
            "label": "firstName",
            "value": myNewFirstName,
        }
        // WE SEND THE HTTP REQUEST
        submitChangeRequest(changeRequest.value, null) // no password verification for first name change
    }
}
const clickedSubmitLastNameChange = (myNewLastName) => {
    const messageValidity = isValidLastName(myNewLastName)
    // The new last name must be different than the current one ...
    if (myNewLastName === user.value.last_name) { 
        // Equivalent to quit the block because there is no change ...
        selectedBlock.value = null
    }
    // Check if last name valid
    else if (messageValidity !== 'success') {
        errorLastNameMessage.value = messageValidity
    }
    else {
        // HERE WE HAVE THE HTTP REQUEST OBJECT
        changeRequest.value = {
            "label": "lastName",
            "value": myNewLastName,
        }
        // WE SEND THE HTTP REQUEST
        submitChangeRequest(changeRequest.value, null) // no password verification for last name change
    }
}
const clickedSubmitCompanyChange = (myNewCompany) => {
    const messageValidity = isValidCompany(myNewCompany)
    // The new company must be different than the current one ...
    if (user.value.company!==null && myNewCompany === user.value.company) { 
        // Equivalent to quit the block because there is no change ...
        selectedBlock.value = null
    }
    // Check if last name valid
    else if (messageValidity !== 'success') {
        errorCompanyMessage.value = messageValidity
    }
    else {
        // HERE WE HAVE THE HTTP REQUEST OBJECT
        changeRequest.value = {
            "label": "company",
            "value": myNewCompany,
        }
        // WE SEND THE HTTP REQUEST
        submitChangeRequest(changeRequest.value, null) // no password verification for company change
    }
}
const clickedSubmitCountryChange = (myNewCountry) => {
    // The new country must be different than the current one ...
    if (user.value.country!==null && myNewCountry === user.value.country) { 
        // Equivalent to quit the block because there is no change ...
        selectedBlock.value = null
    }
    else {
        // HERE WE HAVE THE HTTP REQUEST OBJECT
        changeRequest.value = {
            "label": "country",
            "value": myNewCountry,
        }
        // WE SEND THE HTTP REQUEST
        submitChangeRequest(changeRequest.value, null) // no password verification for country change
    }
}
const clickedSubmitEmailChange = (myNewEmail) => {
    emailNotFree.value = false
    const messageValidity = isValidEmail(myNewEmail)
    // The new email must be different than the current one ...
    if (myNewEmail === user.value.email) { 
        // Equivalent to quit the block because there is no change ...
        selectedBlock.value = null
    }
    // Check if valid email
    else if (messageValidity !== 'success') {
        errorEmailMessage.value = messageValidity
    }
    else {
        // HERE WE HAVE THE HTTP REQUEST OBJECT
        changeRequest.value = {
            "label": "email",
            "value": myNewEmail,
        }
        // WE DO NOT SEND THE HTTP REQUEST DIRECTLY : we open the authentication verification and let the user enter its password, when done it will send the http request
        showPasswordVerificationDialog.value = true
    }
}
const clickedSubmitPasswordChange = () => {
    const messageValidity = isValidPasswordRegister(newPassword1.value)
    // No check about the previous password ...
    // Check if valid email
    if (messageValidity !== 'success') {
        newPassword1.value = null
        newPassword2.value = null
        errorPasswordMessage.value = messageValidity
    }
    else {
        // HERE WE HAVE THE HTTP REQUEST OBJECT
        changeRequest.value = {
            "label": "password",
            "value": newPassword1.value,
        }
        // WE DO NOT SEND THE HTTP REQUEST DIRECTLY : we open the authentication verification and let the user enter its password, when done it will send the http request
        showPasswordVerificationDialog.value = true
    }
}

// - PASSWORD VERIFICATION -
const showPasswordVerificationDialog = ref(false)
const wrongPassword = ref(false)
// Whenever the dialog opens, it should reset the wrongPassword boolean
watchEffect(() => {
    if (showPasswordVerificationDialog.value) { wrongPassword.value = false }
})
const verificationAuthenticationDone = (password) => {
    // IT CALLS THE SUBMIT REQUEST WITH THE PASSWORD AS THE VERIFICATION
    submitChangeRequest(changeRequest.value, password)
}

// - SUBMIT REQUEST -
const showEmailUpdateDoneDialog = ref(false)
const emailRequestContent = ref({ email: "",  password_plain_auth: ""}) // Email only (to be used for the email update popup window if we want to resend)
const submitChangeRequest = async (reqData, passwordVerification) => {
    switch (reqData.label) {
        case 'firstName':
            // Send HTTP request without any passwordVerification
            httpEditProfileLoading.value = true
            try {
                httpEditProfileData.value = await fetchEditProfile({ first_name: reqData.value })
                // Reset of values
                selectedBlock.value = null
                changeRequest.value = null
                // Refresh of data
                store.commit('user/setUser', httpEditProfileData.value.account_info)
                // Success toast
                //toastService.add({ severity: 'success', summary: "Change First Name: Success", detail: 'Your first name has been successfully changed.', life: 5000 });
            } catch (err) {
                handleEditProfileError(err)
            } finally {
                httpEditProfileLoading.value = false
            }
            break;
        case 'lastName':
            // Send HTTP request without any passwordVerification
            httpEditProfileLoading.value = true
            try {
                httpEditProfileData.value = await fetchEditProfile({ last_name: reqData.value })
                // Reset of values
                selectedBlock.value = null
                changeRequest.value = null
                // Refresh of data
                store.commit('user/setUser', httpEditProfileData.value.account_info)
                // Success toast
                //toastService.add({ severity: 'success', summary: "Change Last Name: Success", detail: 'Your last name has been successfully changed.', life: 5000 });
            } catch (err) {
                handleEditProfileError(err)
            } finally {
                httpEditProfileLoading.value = false
            }
            break;
        case 'company':
            // Send HTTP request without any passwordVerification
            httpEditProfileLoading.value = true
            try {
                httpEditProfileData.value = await fetchEditProfile({ company: reqData.value })
                // Reset of values
                selectedBlock.value = null
                changeRequest.value = null
                // Refresh of data
                store.commit('user/setUser', httpEditProfileData.value.account_info)
                // Success toast
                //toastService.add({ severity: 'success', summary: "Change Company: Success", detail: 'Your company has been successfully changed.', life: 5000 });
            } catch (err) {
                handleEditProfileError(err)
            } finally {
                httpEditProfileLoading.value = false
            }
            break;
        case 'country':
            // Send HTTP request without any passwordVerification
            httpEditProfileLoading.value = true
            try {
                httpEditProfileData.value = await fetchEditProfile({ country: reqData.value })
                // Reset of values
                selectedBlock.value = null
                changeRequest.value = null
                // Refresh of data
                store.commit('user/setUser', httpEditProfileData.value.account_info)
                // Success toast
                //toastService.add({ severity: 'success', summary: "Change Country: Success", detail: 'Your country has been successfully changed.', life: 5000 });
            } catch (err) {
                handleEditProfileError(err)
            } finally {
                httpEditProfileLoading.value = false
            }
            break;
        case 'email':
            // Send HTTP request with passwordVerification
            httpEditProfileLoading.value = true
            try {
                emailRequestContent.value = { email: reqData.value,  password_plain_auth: passwordVerification}
                httpEditProfileData.value = await fetchEditProfile({ email: reqData.value,  password_plain_auth: passwordVerification})
                // Reset of values
                showPasswordVerificationDialog.value = false
                selectedBlock.value = null
                changeRequest.value = null
                wrongPassword.value = false
                // Show confirmation dialog
                showEmailUpdateDoneDialog.value = true
                // Refresh of data
                // store.commit('user/setUser', httpEditProfileData.value.account_info)
            } catch (err) {
                handleEditProfileError(err)
            } finally {
                httpEditProfileLoading.value = false
            }
            break;
        case 'password':
            wrongPassword.value = false
            // Send request with passwordVerification
            httpEditProfileLoading.value = true
            try {
                httpEditProfileData.value = await fetchEditProfile({ password_plain: reqData.value, password_plain_auth: passwordVerification })
                // Reset of values
                showPasswordVerificationDialog.value = false
                selectedBlock.value = null
                newPassword1.value = null
                newPassword2.value = null
                changeRequest.value = null
                // Refresh of data
                store.commit('user/setUser', httpEditProfileData.value.account_info)
                // Success toast
                //toastService.add({ severity: 'success', summary: "Change Password: Success", detail: 'Your password has been successfully changed.', life: 5000 });
            } catch (err) {
                handleEditProfileError(err)
            } finally {
                httpEditProfileLoading.value = false
            }
            break;
        default:
            break;
    }
}
// Handle an error from the server
const handleEditProfileError = (error) => {
    try {
        if (error.response == null) { // If there is no .response key, then it means it is not an error from the server, it did not reach it
            toastService.add({ severity: 'error', summary: `Edit Profile: Server not reachable.`, detail: `The server is not reachable. Please make sure you are connected to the internet. If you are, please try again.`, life: 5000 });
            return;
        }
        const errorStatus = error.response.status
        const errorCode = error.response.data.error_code
        const errorMessage = error.response.data.error_message
        switch (errorStatus) {
            case 400: // ACCESS_TOKEN_MISSING / MISSING_OBJ / MISSING_OBJ_ELEM (400)
                if (errorCode == 'ACCESS_TOKEN_MISSING') {
                    toastService.add({ severity: 'error', summary: "Edit Profile: Authorization Issue.", detail: 'You are not logged in.', life: 5000 });
                    // Logout
                    logoutUser()
                }
                else if (errorCode == 'MISSING_OBJ' || errorCode == 'MISSING_OBJ_ELEM') { // MISSING_OBJ / MISSING_OBJ_ELEM
                    toastService.add({ severity: 'warn', summary: "Edit Profile: Missing Information.", detail: 'It seems that the request body does not contain the necessary information.', life: 5000 });
                }
                else { toastService.add({ severity: 'error', summary: `Edit Profile: Error ${errorStatus}.`, detail: errorMessage, life: 12000 }); }
                break;
            case 401: // ACCESS_TOKEN_EXPIRED / ACCESS_TOKEN_INVALID / EMAIL_NOT_FREE / WRONG_PASSWORD (401)
                if (errorCode == 'WRONG_PASSWORD') {
                    wrongPassword.value = true
                }
                else if (errorCode == 'EMAIL_NOT_FREE') {
                    showPasswordVerificationDialog.value = false
                    emailNotFree.value = true
                }
                else if (errorCode == 'ACCESS_TOKEN_EXPIRED' || errorCode == 'ACCESS_TOKEN_INVALID') { // ACCESS_TOKEN_EXPIRED / ACCESS_TOKEN_INVALID : we arrive here only if the token is still invalid AFTER the refresh => logout
                    // Logout: Do nothing, the interceptor should have made a refresh token request!
                    // logoutUser()
                }
                else if (errorCode == 'EMAIL_SENDING_LIMIT_REACHED') {
                    showPasswordVerificationDialog.value = false
                    toastService.add({ severity: 'warn', summary: "Edit Profile: Error Sending Limit.", detail: 'Too much emails have been sent to this address recently; the update confirmation email is not sent. Try later.', life: 5000 });
                }
                else { toastService.add({ severity: 'error', summary: `Edit Profile: Error ${errorStatus}.`, detail: errorMessage, life: 12000 }); }
                break;
            case 404: // Account not found: account has disappear : ACCOUNT_NOT_FOUND (404) => toast + logout
                if (errorCode == 'ACCOUNT_NOT_FOUND') {
                    toastService.add({ severity: 'error', summary: "Edit Profile: Account Not Found.", detail: 'The account no more exists.', life: 5000 });
                    // Logout
                    logoutUser()
                }
                else { toastService.add({ severity: 'error', summary: `Edit Profile: Error ${errorStatus}.`, detail: errorMessage, life: 12000 }); }
                break;
            case 500: // DATABASE_ERROR (500) => toast
                if (errorCode == 'DATABASE_ERROR') {
                    toastService.add({ severity: 'error', summary: "Edit Profile: Internal Error.", detail: 'Sorry, it seems that there is an internal error. Try later.', life: 5000 });
                }
                else { toastService.add({ severity: 'error', summary: `Edit Profile: Error ${errorStatus}.`, detail: errorMessage, life: 12000 }); }
                break;
            default:
                toastService.add({ severity: 'error', summary: `Edit Profile: Error ${errorStatus}.`, detail: errorMessage, life: 12000 });
                break;
        }
    } catch {
        toastService.add({ severity: 'error', summary: `Edit Profile: Server not reachable.`, detail: `The server is not reachable. Please make sure you are connected to the internet. If you are, please try again.`, life: 5000 });
    }
}

// --- DELETE ACCOUNT ---
const showConfirmationDeleteAccountDialog = ref(false);


// --- ENTER key listener ---
onMounted(() => {
    window.addEventListener('keydown', handleKeyPressed)
})
onBeforeUnmount(() => {
    window.removeEventListener('keydown', handleKeyPressed)
}) 
const handleKeyPressed = (event) => {
    if (event.keyCode === 13) { // ENTER
        switch (selectedBlock.value) {
            case 'firstName':
                if (enableChangeFirstNameSubmit.value) { clickedSubmitFirstNameChange(newFirstName.value) }
                break;
            case 'lastName':
                if (enableChangeLastNameSubmit.value) { clickedSubmitLastNameChange(newLastName.value) }
                break;
            case 'company':
                if (enableChangeCompanySubmit.value) { clickedSubmitCompanyChange(newCompany.value) }
                break;
            case 'country':
                if (enableChangeCountrySubmit.value) { clickedSubmitCountryChange(newCountry.value) }
                break;
            case 'email':
                if (enableChangeEmailSubmit.value) { clickedSubmitEmailChange(newEmail1.value) }
                break;
            case 'password':
                if (enableChangePasswordSubmit.value) { clickedSubmitPasswordChange() }
                break;
            default:
                break;
        }
    }
}
</script>

<style scoped>
/* Sections */
.section-title {
    font-size: var(--profile-subtitle-font-size);
    font-weight: var(--profile-subtitle-font-weight);
}
.section-value {
    padding: 0.3rem 0.7rem;
    border-radius: 4px;
    border: 1px solid transparent;
}
/* Selected block */
.selected-block {
    background-color: var(--profile-block-selected-background-color);
    border-radius: var(--my-border-radius);
}
/* Text input */
.inputtext-big.section-inputtext {
    font-size: var(--profile-inputtext-font-size);
    font-weight: var(--profile-inputtext-font-weight);
}
/* Password input */
.inputtext-big.section-password :deep(.p-inputtext), :deep(input::placeholder) {
    font-size: var(--profile-inputtext-font-size);
    font-weight: var(--profile-inputtext-font-weight);
}
.section-password :deep(input) {
    width: 100%;
}
/* Change/Cancel Buttons */
.buttons-change-cancel :deep(.p-button) {
    padding: 0px;
}
.buttons-change-cancel :deep(.p-button:hover) {
    background: transparent;
}
</style>